/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchManualRegistrationOperationV2,
    BatchManualRegistrationOperationV2FromJSON,
    BatchManualRegistrationOperationV2ToJSON,
    BatchRegistrationOperation,
    BatchRegistrationOperationFromJSON,
    BatchRegistrationOperationToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    ManualRegistration,
    ManualRegistrationFromJSON,
    ManualRegistrationToJSON,
    ManualRegistrationBulkCreateParamsV2,
    ManualRegistrationBulkCreateParamsV2FromJSON,
    ManualRegistrationBulkCreateParamsV2ToJSON,
    ManualRegistrationCreateParamsV2,
    ManualRegistrationCreateParamsV2FromJSON,
    ManualRegistrationCreateParamsV2ToJSON,
    ManualRegistrationV2,
    ManualRegistrationV2FromJSON,
    ManualRegistrationV2ToJSON,
    Registration,
    RegistrationFromJSON,
    RegistrationToJSON,
    RegistrationCreateParams,
    RegistrationCreateParamsFromJSON,
    RegistrationCreateParamsToJSON,
    RegistrationList,
    RegistrationListFromJSON,
    RegistrationListToJSON,
    RegistrationStatus,
    RegistrationStatusFromJSON,
    RegistrationStatusToJSON,
    RegistrationUpdateParams,
    RegistrationUpdateParamsFromJSON,
    RegistrationUpdateParamsToJSON,
    SessionCreditUseParams,
    SessionCreditUseParamsFromJSON,
    SessionCreditUseParamsToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
} from '../models';

export interface AbandonRegistrationRequest {
    event_id: string;
    id: string;
}

export interface CancelRegistrationRequest {
    event_id: string;
    id: string;
}

export interface CheckInRegistrationRequest {
    event_id: string;
    id: string;
}

export interface CreateBulkManualRegistrationRequest {
    event_id: string;
    ManualRegistration: Array<ManualRegistration>;
}

export interface CreateBulkManualRegistrationV2Request {
    event_id: string;
    ManualRegistrationBulkCreateParamsV2: ManualRegistrationBulkCreateParamsV2;
}

export interface CreateManualRegistrationRequest {
    event_id: string;
    ManualRegistration: ManualRegistration;
}

export interface CreateManualRegistrationV2Request {
    event_id: string;
    ManualRegistrationCreateParamsV2: ManualRegistrationCreateParamsV2;
}

export interface CreateRegistrationRequest {
    event_id: string;
    RegistrationCreateParams: RegistrationCreateParams;
}

export interface DeleteRegistrationRequest {
    event_id: string;
    id: string;
}

export interface FindOneRegistrationRequest {
    event_id: string;
    id: string;
}

export interface FindRegistrationsRequest {
    event_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    status?: Array<RegistrationStatus>;
    program_attendee_id?: string;
}

export interface RefundRegistrationRequest {
    event_id: string;
    id: string;
}

export interface ReserveSpotRegistrationRequest {
    event_id: string;
    id: string;
}

export interface UndoCheckInRegistrationRequest {
    event_id: string;
    id: string;
}

export interface UndoRefundRegistrationRequest {
    event_id: string;
    id: string;
}

export interface UnreserveSpotRegistrationRequest {
    event_id: string;
    id: string;
}

export interface UpdateRegistrationRequest {
    event_id: string;
    id: string;
    RegistrationUpdateParams: RegistrationUpdateParams;
}

export interface UseCreditRegistrationRequest {
    event_id: string;
    id: string;
    SessionCreditUseParams: SessionCreditUseParams;
}

/**
 * 
 */
export class RegistrationsApi extends runtime.BaseAPI {

    /**
     * Abandon a registration for event
     */
    async abandonRegistrationRaw(requestParameters: AbandonRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling abandonRegistration.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling abandonRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/registrations/{id}/abandon`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Abandon a registration for event
     */
    async abandonRegistration(requestParameters: AbandonRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.abandonRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel a registration for event
     */
    async cancelRegistrationRaw(requestParameters: CancelRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling cancelRegistration.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling cancelRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/registrations/{id}/cancel`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Cancel a registration for event
     */
    async cancelRegistration(requestParameters: CancelRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.cancelRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Checkin a registration for event
     */
    async checkInRegistrationRaw(requestParameters: CheckInRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling checkInRegistration.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling checkInRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/registrations/{id}/check_in`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Checkin a registration for event
     */
    async checkInRegistration(requestParameters: CheckInRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.checkInRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create manual registrations in bulk
     */
    async createBulkManualRegistrationRaw(requestParameters: CreateBulkManualRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchRegistrationOperation>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling createBulkManualRegistration.');
        }

        if (requestParameters.ManualRegistration === null || requestParameters.ManualRegistration === undefined) {
            throw new runtime.RequiredError('ManualRegistration','Required parameter requestParameters.ManualRegistration was null or undefined when calling createBulkManualRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/manual_registrations/bulk`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.ManualRegistration.map(ManualRegistrationToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchRegistrationOperationFromJSON(jsonValue));
    }

    /**
     * Create manual registrations in bulk
     */
    async createBulkManualRegistration(requestParameters: CreateBulkManualRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchRegistrationOperation> {
        const response = await this.createBulkManualRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create manual registrations in bulk
     */
    async createBulkManualRegistrationV2Raw(requestParameters: CreateBulkManualRegistrationV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchManualRegistrationOperationV2>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling createBulkManualRegistrationV2.');
        }

        if (requestParameters.ManualRegistrationBulkCreateParamsV2 === null || requestParameters.ManualRegistrationBulkCreateParamsV2 === undefined) {
            throw new runtime.RequiredError('ManualRegistrationBulkCreateParamsV2','Required parameter requestParameters.ManualRegistrationBulkCreateParamsV2 was null or undefined when calling createBulkManualRegistrationV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/events/{event_id}/manual_registrations/bulk`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ManualRegistrationBulkCreateParamsV2ToJSON(requestParameters.ManualRegistrationBulkCreateParamsV2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchManualRegistrationOperationV2FromJSON(jsonValue));
    }

    /**
     * Create manual registrations in bulk
     */
    async createBulkManualRegistrationV2(requestParameters: CreateBulkManualRegistrationV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchManualRegistrationOperationV2> {
        const response = await this.createBulkManualRegistrationV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Create manual registration
     */
    async createManualRegistrationRaw(requestParameters: CreateManualRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling createManualRegistration.');
        }

        if (requestParameters.ManualRegistration === null || requestParameters.ManualRegistration === undefined) {
            throw new runtime.RequiredError('ManualRegistration','Required parameter requestParameters.ManualRegistration was null or undefined when calling createManualRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/manual_registrations`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ManualRegistrationToJSON(requestParameters.ManualRegistration),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * @deprecated Create manual registration
     */
    async createManualRegistration(requestParameters: CreateManualRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.createManualRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create manual registration
     */
    async createManualRegistrationV2Raw(requestParameters: CreateManualRegistrationV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ManualRegistrationV2>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling createManualRegistrationV2.');
        }

        if (requestParameters.ManualRegistrationCreateParamsV2 === null || requestParameters.ManualRegistrationCreateParamsV2 === undefined) {
            throw new runtime.RequiredError('ManualRegistrationCreateParamsV2','Required parameter requestParameters.ManualRegistrationCreateParamsV2 was null or undefined when calling createManualRegistrationV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/events/{event_id}/manual_registrations`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ManualRegistrationCreateParamsV2ToJSON(requestParameters.ManualRegistrationCreateParamsV2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManualRegistrationV2FromJSON(jsonValue));
    }

    /**
     * Create manual registration
     */
    async createManualRegistrationV2(requestParameters: CreateManualRegistrationV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ManualRegistrationV2> {
        const response = await this.createManualRegistrationV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create registration
     */
    async createRegistrationRaw(requestParameters: CreateRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling createRegistration.');
        }

        if (requestParameters.RegistrationCreateParams === null || requestParameters.RegistrationCreateParams === undefined) {
            throw new runtime.RequiredError('RegistrationCreateParams','Required parameter requestParameters.RegistrationCreateParams was null or undefined when calling createRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/registrations`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegistrationCreateParamsToJSON(requestParameters.RegistrationCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Create registration
     */
    async createRegistration(requestParameters: CreateRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.createRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete registration
     */
    async deleteRegistrationRaw(requestParameters: DeleteRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling deleteRegistration.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/registrations/{id}`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete registration
     */
    async deleteRegistration(requestParameters: DeleteRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find registration by id
     */
    async findOneRegistrationRaw(requestParameters: FindOneRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling findOneRegistration.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/registrations/{id}`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Find registration by id
     */
    async findOneRegistration(requestParameters: FindOneRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.findOneRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all registrations by event
     */
    async findRegistrationsRaw(requestParameters: FindRegistrationsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RegistrationList>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling findRegistrations.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.program_attendee_id !== undefined) {
            queryParameters['program_attendee_id'] = requestParameters.program_attendee_id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/registrations`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationListFromJSON(jsonValue));
    }

    /**
     * List all registrations by event
     */
    async findRegistrations(requestParameters: FindRegistrationsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RegistrationList> {
        const response = await this.findRegistrationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Refund a registration for event
     */
    async refundRegistrationRaw(requestParameters: RefundRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling refundRegistration.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling refundRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/registrations/{id}/refund`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Refund a registration for event
     */
    async refundRegistration(requestParameters: RefundRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.refundRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reserve a registration for event
     */
    async reserveSpotRegistrationRaw(requestParameters: ReserveSpotRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling reserveSpotRegistration.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling reserveSpotRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/registrations/{id}/reserve`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Reserve a registration for event
     */
    async reserveSpotRegistration(requestParameters: ReserveSpotRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.reserveSpotRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Undo checkin on a registration for event
     */
    async undoCheckInRegistrationRaw(requestParameters: UndoCheckInRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling undoCheckInRegistration.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling undoCheckInRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/registrations/{id}/undo_check_in`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Undo checkin on a registration for event
     */
    async undoCheckInRegistration(requestParameters: UndoCheckInRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.undoCheckInRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Undo refund on a registration for event
     */
    async undoRefundRegistrationRaw(requestParameters: UndoRefundRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling undoRefundRegistration.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling undoRefundRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/registrations/{id}/undo_refund`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Undo refund on a registration for event
     */
    async undoRefundRegistration(requestParameters: UndoRefundRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.undoRefundRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unreserve a registration for event
     */
    async unreserveSpotRegistrationRaw(requestParameters: UnreserveSpotRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling unreserveSpotRegistration.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling unreserveSpotRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/registrations/{id}/unreserve`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Unreserve a registration for event
     */
    async unreserveSpotRegistration(requestParameters: UnreserveSpotRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.unreserveSpotRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update registration
     */
    async updateRegistrationRaw(requestParameters: UpdateRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling updateRegistration.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateRegistration.');
        }

        if (requestParameters.RegistrationUpdateParams === null || requestParameters.RegistrationUpdateParams === undefined) {
            throw new runtime.RequiredError('RegistrationUpdateParams','Required parameter requestParameters.RegistrationUpdateParams was null or undefined when calling updateRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/registrations/{id}`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RegistrationUpdateParamsToJSON(requestParameters.RegistrationUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Update registration
     */
    async updateRegistration(requestParameters: UpdateRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.updateRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Uses an attendee\'s credit for registration
     */
    async useCreditRegistrationRaw(requestParameters: UseCreditRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling useCreditRegistration.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling useCreditRegistration.');
        }

        if (requestParameters.SessionCreditUseParams === null || requestParameters.SessionCreditUseParams === undefined) {
            throw new runtime.RequiredError('SessionCreditUseParams','Required parameter requestParameters.SessionCreditUseParams was null or undefined when calling useCreditRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/events/{event_id}/registrations/{id}/use_credit`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SessionCreditUseParamsToJSON(requestParameters.SessionCreditUseParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Uses an attendee\'s credit for registration
     */
    async useCreditRegistration(requestParameters: UseCreditRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.useCreditRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
